import { CompactInput, PropertiesPanelControl, PropertiesPanelLabel, PropertiesPanelProperty } from './propertiesPanelProperty';
import React from 'react';
import styled from 'styled-components';

const NumberInput = styled(CompactInput)`
    width: 100%;
    text-align: center;
`;

export type PropertiesPanelNumberPropertyProps = {
    id: string;
    label: React.ReactNode;
    value: number;
    min?: number;
    max?: number;
    step?: number;
    onChange?: (newValue: number, e: React.ChangeEvent<HTMLInputElement>) => void;
    disabled?: boolean;
};
export const PropertiesPanelNumberProperty: React.FC<PropertiesPanelNumberPropertyProps> = ({ id, label, value, onChange, disabled, min, max, step }) => {
    return (
        <PropertiesPanelProperty>
            <PropertiesPanelLabel htmlFor={`${id}-input`}>{label}</PropertiesPanelLabel>
            <PropertiesPanelControl>
                <NumberInput
                    id={`${id}-input`}
                    type={'number'}
                    min={min}
                    max={max}
                    step={step}
                    value={value}
                    disabled={disabled}
                    onChange={(e) => {
                        if (!isNaN(e.target.valueAsNumber)) {
                            onChange?.(e.target.valueAsNumber, e);
                        }
                    }}
                />
            </PropertiesPanelControl>
        </PropertiesPanelProperty>
    );
};
